import { render, staticRenderFns } from "./CouponPanel.vue?vue&type=template&id=4ca34ae1&scoped=true"
import script from "./CouponPanel.vue?vue&type=script&lang=js"
export * from "./CouponPanel.vue?vue&type=script&lang=js"
import style0 from "./CouponPanel.vue?vue&type=style&index=0&id=4ca34ae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca34ae1",
  null
  
)

export default component.exports